/*!
 * devextreme-angular
 * Version: 16.2.5
 * Build date: Tue Feb 28 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var nested_option_1 = require('../../core/nested-option');
var nested_option_2 = require('../../core/nested-option');
var DxoFieldChooserComponent = (function (_super) {
    __extends(DxoFieldChooserComponent, _super);
    function DxoFieldChooserComponent(parentOptionHost, optionHost) {
        _super.call(this);
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    Object.defineProperty(DxoFieldChooserComponent.prototype, "enabled", {
        get: function () {
            return this._getOption('enabled');
        },
        set: function (value) {
            this._setOption('enabled', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoFieldChooserComponent.prototype, "height", {
        get: function () {
            return this._getOption('height');
        },
        set: function (value) {
            this._setOption('height', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoFieldChooserComponent.prototype, "layout", {
        get: function () {
            return this._getOption('layout');
        },
        set: function (value) {
            this._setOption('layout', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoFieldChooserComponent.prototype, "texts", {
        get: function () {
            return this._getOption('texts');
        },
        set: function (value) {
            this._setOption('texts', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoFieldChooserComponent.prototype, "title", {
        get: function () {
            return this._getOption('title');
        },
        set: function (value) {
            this._setOption('title', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoFieldChooserComponent.prototype, "width", {
        get: function () {
            return this._getOption('width');
        },
        set: function (value) {
            this._setOption('width', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoFieldChooserComponent.prototype, "_optionPath", {
        get: function () {
            return 'fieldChooser';
        },
        enumerable: true,
        configurable: true
    });
    DxoFieldChooserComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'dxo-field-chooser',
                    template: '',
                    styles: [''],
                    providers: [nested_option_1.NestedOptionHost]
                },] },
    ];
    DxoFieldChooserComponent.ctorParameters = function () { return [
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.SkipSelf }, { type: core_1.Host },] },
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.Host },] },
    ]; };
    DxoFieldChooserComponent.propDecorators = {
        'enabled': [{ type: core_1.Input },],
        'height': [{ type: core_1.Input },],
        'layout': [{ type: core_1.Input },],
        'texts': [{ type: core_1.Input },],
        'title': [{ type: core_1.Input },],
        'width': [{ type: core_1.Input },],
    };
    return DxoFieldChooserComponent;
}(nested_option_2.NestedOption));
exports.DxoFieldChooserComponent = DxoFieldChooserComponent;
var DxoFieldChooserModule = (function () {
    function DxoFieldChooserModule() {
    }
    DxoFieldChooserModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [
                        DxoFieldChooserComponent
                    ],
                    exports: [
                        DxoFieldChooserComponent
                    ],
                },] },
    ];
    DxoFieldChooserModule.ctorParameters = function () { return []; };
    return DxoFieldChooserModule;
}());
exports.DxoFieldChooserModule = DxoFieldChooserModule;
//# sourceMappingURL=field-chooser.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme-angular/ui/nested/field-chooser.js
// module id = ../../../../devextreme-angular/ui/nested/field-chooser.js
// module chunks = 3